import { Industry, IndustriesListModel } from '@/modules/industries/types'
import { useAxiosModule } from '@/modules/_shared/axios'
import * as types from '@/modules/organizations/types'
const { postToApi, getFromApi, deleteInApi, patchToApi } = useAxiosModule()

export type GetIndustriesListResponse = IndustriesListModel[]
const getIndustriesListUrl = 'industries'

export async function getIndustriesList () {
    return getFromApi<GetIndustriesListResponse>(getIndustriesListUrl)
}

export type GetIndustryResponse = Industry
const getIndustryUrl = 'industries/'

export async function getSingleIndustry (id: string) {
    return getFromApi<GetIndustryResponse>(getIndustryUrl + id)
}

export type AddIndustryRequest = Industry

const addIndustryUrl = 'industries/create'

export async function addSingleIndustry (req: AddIndustryRequest) {
    return postToApi<null>(addIndustryUrl, req)
}

export type UpdateIndustryRequest = Industry

const updateIndustryUrl = 'industries/update/'

export async function updateSingleIndustry (id: string, req: UpdateIndustryRequest) {
    return patchToApi<null>(updateIndustryUrl + id, req)
}

const deleteIndustryUrl = 'industries/'

export async function deleteSingleIndustry (id: string) {
    return deleteInApi<null>(deleteIndustryUrl + id)
}

export type GetIndustryOrganizationsListResponse = types.OrganizationsSimplifiedListModel[]
export async function getIndustryOrganizationsList (id: string) {
    return getFromApi<GetIndustryOrganizationsListResponse>('industries/' + id + '/organizations')
}
